import {
    createUserWithEmailAndPassword,
    getAuth,
    updateProfile,
} from "firebase/auth";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DHLogo from "../assets/PeranaSportsSquare512.png";
import { initPageTranslations } from "../utils/utils";

import {
    serverTimestamp,
} from "firebase/firestore";
import { updateUser } from "../utils/dbutils";

function SignUp() {
  const navigate = useNavigate();
  const phrases = [
    "Register account",
    "Full name",
    "Email address",
    "Password",
    "Register",
    "Already a member?",
    "Sign in",
    "Please enter first name and last name.",
    "Signed up successfully",
    "Error signing up",
  ];
  const [translations, setTranslations] = useState(null);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    console.log(data);
    const { fullname, email, password } = data;
    const names = fullname.split(" ");
    if (names.length < 2) {
      toast.error("Please enter first name and last name.");
      return;
    }

    try {
      const auth = getAuth();
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      updateProfile(auth.currentUser, {
        displayName: fullname,
      });
      const formDataCopy = { ...data };
      delete formDataCopy.password;
      formDataCopy.timestamp = serverTimestamp();

      const usr = {
        email: user.email,
        name: fullname,
        role: 0,
        uid: user.uid,
      };
      await updateUser(usr);
      toast.success("Signed up successfully");
      navigate("/frontpage");
    } catch (error) {
      toast.error("Error signing up" + "\n" + error.message);
    }
  };

  const initTranslations = async () => {
    const tr = await initPageTranslations(phrases, "SignUp");
    setTranslations(tr);
  };

  useEffect(() => {
    if (!translations) {
      initTranslations();
    }
  }, [translations]);

  if (!translations) return <></>;

  return (
    <>
      <div className="h-[92vh]">
        <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
          <div className="w-full max-w-sm space-y-10">
            <div className="mt-10">
              <img
                className="mx-auto h-28 w-auto"
                src={DHLogo}
                alt="Dong Hanh"
              />
              <h2 className="mt-4 text-center text-2xl font-bold leading-9 tracking-tight text-base-content">
                {translations["Register account"]}
              </h2>
            </div>
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <div className="relative -space-y-px rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-0 z-10 rounded-md ring-1 ring-inset ring-base-300" />
                <div>
                  <label htmlFor="fullname" className="sr-only">
                    {translations["Full name"]}
                  </label>
                  <input
                    {...register("fullname")}
                    id="fullname"
                    name="fullname"
                    type="fullname"
                    autoComplete="fullname"
                    required
                    className="relative block w-full rounded-t-md border-0 p-1.5 text-base-content ring-1 ring-inset ring-base-300 placeholder:text-base-content/50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={translations["Full name"]}
                  />
                </div>
                <div>
                  <label htmlFor="email-address" className="sr-only">
                    {translations["Email address"]}
                  </label>
                  <input
                    {...register("email")}
                    id="email-address"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="relative block w-full rounded-t-md border-0 p-1.5 text-base-content ring-1 ring-inset ring-base-300 placeholder:text-base-content/50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={translations["Email address"]}
                  />
                </div>
                <div>
                  <label htmlFor="password" className="sr-only">
                    {translations["Password"]}
                  </label>
                  <input
                    {...register("password")}
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    className="relative block w-full rounded-b-md border-0 p-1.5 text-base-content ring-1 ring-inset ring-base-300 placeholder:text-base-content/50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={translations["Password"]}
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-primary px-3 py-1.5 text-sm font-semibold leading-6 text-primary-content hover:bg-primary-focus focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  {translations["Register"]}
                </button>
              </div>
            </form>

            <p className="text-center text-sm leading-6 text-base-content/60">
              {translations["Already a member?"]}
              <a
                href="/sign-in"
                className="font-semibold text-primary hover:text-primary-focus"
              >
                {" "}
                {translations["Sign in"]}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;
